import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { useEffect, useState } from 'react';
import { numberToString } from '../../special/numberConverter';
import { useConfig } from '../../../api/api';
import MoneyLabel from '../../label/MoneyLabel';

const Sum = ({ sum, cols, collapseModules }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const [columnCount, setColumnCount] = useState(null);
  const [mobileHiddenCount, setMobileHiddenCount] = useState(null);

  useEffect(() => {
    var newColumnCount = 0;
    var newMobileHiddenCount = 0;
    cols.forEach((col) => {
      if (!col.hidden) {
        newColumnCount++;

        if (col.hideOnMobile) newMobileHiddenCount++;
      }
    });
    setMobileHiddenCount(newMobileHiddenCount);
    setColumnCount(newColumnCount);
  }, [cols]);

  return (
    <>
      <SumElement
        collapseModules={collapseModules}
        mobileHiddenCount={mobileHiddenCount}
        colSpan={columnCount}
        sum={sum.netto}
        text="Netto"
        currency={config && config.currency.currencySymbol}
      />

      <SumElement
        collapseModules={collapseModules}
        mobileHiddenCount={mobileHiddenCount}
        colSpan={columnCount}
        sum={sum.tax}
        text="MwSt."
        currency={config && config.currency.currencySymbol}
      />

      <SumElement
        cols={cols}
        collapseModules={collapseModules}
        mobileHiddenCount={mobileHiddenCount}
        colSpan={columnCount}
        sum={sum.netto + sum.tax}
        text="Brutto"
        currency={config && config.currency.currencySymbol}
      />
    </>
  );
};

const SumElement = ({
  cols,
  colSpan,
  sum,
  text,
  mobileHiddenCount,
  collapseModules,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const colCorrection = collapseModules ? 1 : 2;

  const colsToAdd =
    colSpan - colCorrection - 2 > 0 ? colSpan - colCorrection - 2 : 0;

  return (
    <tr>
      {/*Array(colsToAdd)
        .fill(null)
        .map((col, index) => (
          <td
            key={index}
            className={`w-full ${
              index < mobileHiddenCount ? 'hidden md:table-cell' : ''
            }`}
            style={{ width: cols && cols[index].width }}
          ></td>
        ))*/}
      <td colSpan={colsToAdd - 2}></td>
      <td></td>
      <td className="hidden md:table-cell"></td>
      <td colSpan={2}>
        <Box className="w-full text-right pb-2">{text}</Box>
      </td>
      <td colSpan={2}>
        <Box className="w-full flex justify-end">
          <Box className="w-[130px] text-right monospace pr-1 pb-2">
            <MoneyLabel money={sum} />
          </Box>
        </Box>
      </td>
    </tr>
  );
};

export default Sum;
